import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentRoute: localStorage.getItem("lastVisitedRoute") || "/",  
};

export const routeSlice = createSlice({
  name: "Allroutes",
  initialState,
  reducers: {
    setRoute: (state, action) => {
      state.currentRoute = action.payload;
      localStorage.setItem("lastVisitedRoute", action.payload); 
    },
  },
});

export const { setRoute } = routeSlice.actions;

export default routeSlice.reducer;
